// Layout.jsx
import { Outlet } from "react-router-dom";
import Header from "./Header";
import NotificationSystem from "./Notifications";
import ModalsSystem from "./Modals";

const Layout = () => {
  return (
    <>
      <Header />
      <main>
        <Outlet />
        <NotificationSystem />
        <ModalsSystem />
      </main>
    </>
  );
};

export default Layout;
